import clsx from 'clsx';
import { ElementsIconProps } from '../components';

export function EsFinancialHealthIcon({ className, ...props }: ElementsIconProps) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={clsx(className, 'h-5 w-5')}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="8" fill="#00A36C" />
      <g fill="white">
        <path d="M12.7083 14.0499V15.9999H6.78027V7.54993H12.5783V9.49993H9.05527V10.8064H12.0193V12.5744H9.05527V14.0499H12.7083Z" />
        <path
          transform="matrix(0.8 0 0 0.88 9.2 4.09)"
          d="M10.885 11.2156C10.885 12.586 9.74747 13.431 8.12247 13.431C6.49205 13.431 5.17039 12.7485 5.05664 10.9664L6.8658 10.7823C6.94705 11.5568 7.35872 11.8548 8.10622 11.8548C8.70205 11.8548 8.95122 11.6543 8.95122 11.3456C8.95122 11.0152 8.64247 10.8635 7.65664 10.636C6.05331 10.2677 5.21914 9.73684 5.21914 8.40975C5.21914 6.95267 6.41622 6.19434 7.88955 6.19434C9.6933 6.19434 10.6629 6.996 10.82 8.686L9.12997 8.87017C9.01622 8.09559 8.60455 7.75975 7.92205 7.75975C7.36955 7.75975 7.13122 8.0035 7.13122 8.28517C7.13122 8.63184 7.39122 8.79434 8.70747 9.13017C10.1158 9.49309 10.885 10.0239 10.885 11.2156Z"
        />
      </g>
    </svg>
  );
}
